export default function PoliticasYPostularATicketGratis({ LogoEmpresa, openSolicitudEnviada }) {

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 bg-aw-bgbluedark-30 rounded-lg max-h-[90vh] overflow-hidden shadow-lg">
      <div className="hidden sm:block">
        <img
          src={LogoEmpresa}
          alt="Sign In"
          className="w-full h-full object-cover object-center rounded-t-2xl sm:rounded-l-rounded-t-2xl"
        />
      </div>
      <div
        className={`p-8 flex flex-col justify-center bg-aw-bluedark rounded-b-rounded-t-2xl sm:rounded-r-rounded-t-2xl text-white relative`}
      >
        {/* Mobile background image with overlay */}
        <div className="absolute inset-0 sm:hidden">
          <img
            src={LogoEmpresa}
            alt="Sign In"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-aw-bluedark-75 backdrop-blur-[1.5px]" />
        </div>
        <div className="relative z-10">
          <h4 className="text-xl font-bold mb-4">
            Políticas para postular a ticket gratis
          </h4>
          <div className="mb-4 max-h-[300px] overflow-y-auto scrollbar-box thin pr-2">
            <ul className="list-disc list-inside space-y-2 text-sm">
              <li>Solo puedes postular a un ticket gratis por evento.</li>
              <li>
                Debes completar tu perfil con información verídica y actualizada.
              </li>
              <li>
                La selección de ganadores se realiza de manera aleatoria entre
                todos los postulantes que cumplan con los requisitos.
              </li>
              <li>
                Si resultas ganador, recibirás un correo electrónico con las
                instrucciones para reclamar tu ticket.
              </li>
              </ul>
              <ul className="list-disc list-inside space-y-2 text-sm mt-4">
              <li>
                Al postularte, aceptas que tu información sea compartida con la
                empresa organizadora del evento.
              </li>
              <li>
                Nos reservamos el derecho de descalificar a cualquier
                postulante que intente manipular el proceso de selección.
              </li>
              <li>
                Estas políticas pueden ser actualizadas en cualquier momento sin
                previo aviso.
              </li>
            </ul>
          </div>
          <button
          onClick={() => {
            openSolicitudEnviada();
          }}
            className="w-full py-2 mt-4 bg-aw-green text-aw-bluedark font-bold rounded hover:scale-95 duration-300 transition-scale"
          >
            Aceptar y postularme
          </button>
        </div>
      </div>
    </div>
  );
}
